<template>
        <div class="bg-box grid grid-cols-4 row-gap-3 col-gap-2 mx-4 mb-2 text-white p-4 rounded-md">
            <template v-for="store in stores" v-if="store.name !== 'Web'">
                <div class="bg-module rounded px-2 flex flex-col" :key="store.id">
                    <div class="text-aux ml-2 text-lg mb-1">{{store.name}}</div>
                    <div class="text-light ml-2">{{store.date}}</div>
                    <div class="flex justify-between px-4 text-xl  my-auto">
                        <div>{{store.current_amount | numberFormat(2)}}€</div>
                        <div class="text-success-30 text-lg">{{store.orders}}<ShopIcon class="ml-1 text-success"/></div>
                    </div>
                    <div class="text-center text-lg text-success-30">{{store.percent}}%</div>
                    <SalesBar data="store.percent"/>
                </div>   
            </template>
        </div>
</template>
<script>

import ShopIcon from '@/components/icons/ShopIcon.vue'
import SalesBar from '@/components/SalesBar.vue'

    export default {
        name: 'salesStore',

        props: {
            stores: {
                type: Array,
                required: true
            }
        },

        components: {
            ShopIcon,
            SalesBar
        }
    }
</script>

<style scoped>

</style>